// import external dependencies
import 'jquery';

// Import everything from autoload
import './autoload/_bootstrap.js'

import { tns } from 'tiny-slider/src/tiny-slider';
import Cookies from 'js-cookie/src/js.cookie';
import AOS from 'aos';
import Swup from 'swup';

jQuery(document).ready(function() {
  const origin = window.location.origin;

  const swup = new Swup({
    linkSelector: 'a[href^="' + origin + '"]:not([href^="' + origin + '#"]):not([href^="' + origin + '/find"])',
  });

  // Get breakpoints from bootstrap CSS with fallback for old browsers
  const breakpoints = {
    'xs': parseInt(getComputedStyle(document.documentElement, null).getPropertyValue('--breakpoint-xs'), 10) || 0,
    'sm': parseInt(getComputedStyle(document.documentElement, null).getPropertyValue('--breakpoint-sm'), 10) || 576,
    'md': parseInt(getComputedStyle(document.documentElement, null).getPropertyValue('--breakpoint-md'), 10) || 768,
    'lg': parseInt(getComputedStyle(document.documentElement, null).getPropertyValue('--breakpoint-lg'), 10) || 992,
    'xl': parseInt(getComputedStyle(document.documentElement, null).getPropertyValue('--breakpoint-xl'), 10) || 1200,
  };

  const $body = $('body');

  let page_hero_shown;
  let main_header_is_fixed;

  swup.on('contentReplaced', function() {
    // fix bootstrap collapse toggles
    $('[data-toggle="collapse"]').collapse();

    // fix gravity forms Ajax
    $('.js-gravity-form-wrap').each(function() {
      var $gf_wrap = $(this);
      var id = $gf_wrap.data('form-id');

      $.get(
        window.admin_ajax_url,
        {
          action: 'load_gravity_form',
          id: id,
        },
        function(html) {
          $gf_wrap.html(html);
        }
      );
    });

    onPageLoad();
  });

  swup.on('clickLink', function() {
    // hide nav menu
    menu_hidden();
  });

  swup.on('animationOutDone', function() {
    $(window).scrollTop(0);
  });

  $body
    .on('fixed-menu-show', function() {
      $body.addClass('fixed-menu-open');

      // add padding to account for scrollbar hiding
      const $scroll_div = $('<div>', {
        'class': 'modal-scrollbar-measure',
      });
      $body.append($scroll_div);
      const scrollbarWidth = $scroll_div[0].getBoundingClientRect().width - $scroll_div[0].clientWidth;
      $scroll_div.remove();

      $body.css('padding-right', scrollbarWidth);
    });

  $body
    .on('fixed-menu-hidden', function() {
      $body.removeClass('fixed-menu-open');
      $body.css('padding-right', '');
    });

  function menu_show() {
    $body.trigger('fixed-menu-show');

    // make sure the header is fixed after resize
    $(window)
      .on('resize.nav-menu orientationchange.nav-menu', function(){
        if(!main_header_is_fixed) {
          $(window).scrollTop($('#top').offset().top + 1);
        }
      });
  }

  function menu_hidden() {
    $body.trigger('fixed-menu-hidden');

    $(window).off('resize.nav-menu orientationchange.nav-menu');
  }


  // Show newsletter modal after x time
  const $newsletter_modal = $('#modal-newsletter-signup');
  let newsletter_form_ids = [-1];
  let newsletter_modal_timeout = null;

  if($newsletter_modal.length) {
    const newsletter_countdown_time = $newsletter_modal.data('timeout');
    newsletter_form_ids = $newsletter_modal.data('form-ids').split(',');

    newsletter_modal_timeout = setTimeout(function() {
      $newsletter_modal.modal('show');
    }, newsletter_countdown_time);

    // remove newsletter modal timeout if they already opened it
    $newsletter_modal.on('show.bs.modal', remove_newsletter_modal_timeout);
  }

  function remove_newsletter_modal_timeout() {
    clearTimeout(newsletter_modal_timeout);

    Cookies.set('newsletter_modal_shown', 'true');
  }

  function isInViewport(node) {
    var rect = node.getBoundingClientRect()
    return ((rect.height > 0 || rect.width > 0) && rect.bottom >= 0 && rect.right >= 0 && rect.top <= (window.innerHeight || document.documentElement.clientHeight) && rect.left <= (window.innerWidth || document.documentElement.clientWidth))
  }

  // show modal on gravity form success
  $(document)
    .on('gform_confirmation_loaded', function(e, form_id) {
      const $confirmation_modal = $('#modal-gform-' + form_id + '-confirmation');

      if($confirmation_modal.length) {
        // close all modals first
        $('.modal').modal('hide');

        // remove newsletter modal timeout if they already signed up!
        if(newsletter_modal_timeout && newsletter_form_ids.indexOf(form_id.toString()) !== -1) {
          remove_newsletter_modal_timeout();
        }

        // show form success modal
        $confirmation_modal.modal('show');
      }
    });

  onPageLoad();

  function onPageLoad() {
    // run animations
    AOS.init({
      duration: 1000,
    });

    // update AOS positions when opening collapsable elements
    $('.collapse')
      .on('shown.bs.collapse hidden.bs.collapse', function () {
        AOS.refresh();
      });

    $('.fixed-menu')
      .on('show.bs.collapse', function() {
        $(this).addClass('opened');
      })
      .on('hide.bs.collapse', function() {
        $(this).removeClass('opened');
      });

    // Smooth scroll to hash links
    $('.js-smooth-scroll')
      .on('click', function(e) {
        const $link = $(this);
        const $target = $(this.hash);

        if ($target.length) {
          e.preventDefault();

          const ignore_header = $link.data('ignore-header');
          const $header = $('#main-header');
          const header_height = $header.outerHeight();
          let target_offset = $target.offset().top;

          if(!ignore_header && target_offset > header_height) {
            target_offset -= header_height;
          }

          $('html, body').animate({
            scrollTop: target_offset,
          }, 1000);
        }
      });

    // required due to modal triggers within WordPress menus
    $('a[href^="#modal-"]')
      .on('click', function(e) {
        e.preventDefault();

        const $anchor = $(this);
        const $modal = $($anchor.attr('href'));

        if($modal.length) {
          $modal.modal('show');
        }
      });

    const $page_hero = $('#page-hero');
    const $main_header = $('#main-header-wrap');
    const $main_header_navbar_wrap = $('#main-header-menu-wrap');
    const $main_header_navbar_wrap_overlay = $('#main-header-menu-overlay')
    page_hero_shown = ($page_hero.length > 0);
    main_header_is_fixed = !page_hero_shown;

    $main_header_navbar_wrap_overlay
      .on('click.fixed-menu-hide', function() {
        $main_header_navbar_wrap.collapse('hide');
      });

    // https://stackoverflow.com/a/57991537
    const main_header_sticky_observer = new IntersectionObserver(
      function([e]) {
        const is_fixed = (e.intersectionRatio < 1);

        $main_header.toggleClass('is-fixed', is_fixed);

        main_header_is_fixed = is_fixed;
      },
      { threshold: [1] }
    );

    main_header_sticky_observer.observe($main_header[0]);

    $main_header_navbar_wrap
      .on('show.bs.collapse', function(e) {
        if(page_hero_shown) {
          if(!main_header_is_fixed) {
            e.preventDefault();

            $('html, body').animate({
              scrollTop: ($('#top').offset().top + 1), // add 1px to trigger observer
            }, 250, function(){
              $main_header_navbar_wrap.collapse('show');
            });
          }
          else {
            menu_show();
          }
        }
        else {
          menu_show();
        }
      })
      .on('hidden.bs.collapse', function() {
        menu_hidden();
      });

    const $main_nav = $('#menu-primary-navigation');
    const $main_nav_sub_menu_toggles = $main_nav.find('.menu-item-has-children > a');
    const $main_nav_sub_menus = $main_nav.find('.sub-menu');

    // initalize collapse on all sub menus
    $main_nav_sub_menus
      .each(function(index){
        const $sub_nav = $(this);
        const $sub_nav_toggle = $sub_nav.prev('a');
        const $parent_sub_navs = $sub_nav.parents('.sub-menu');
        // set parent to main nav if no parent sub nav
        const $parent_sub_nav = $parent_sub_navs.length ? $parent_sub_navs.first() : $main_nav;

        $sub_nav.attr({
          'id': 'main-header-navbar-sub-menu-' + index,
          'data-level': $parent_sub_navs.length + 1,
        });

        $sub_nav_toggle.attr({
          'href': '#main-header-navbar-sub-menu-' + index,
          'aria-expanded': 'false',
          'aria-controls': 'main-header-navbar-sub-menu-' + index,
          'aria-label': 'Toggle sub navigation',
        });

        $sub_nav.collapse({
          parent: $parent_sub_nav,
          toggle: false,
        });
      });

    // toggle active class on sub menu link
    $main_nav_sub_menus
      .on('show.bs.collapse hide.bs.collapse', function(e) {
        e.stopPropagation(); // stop parent sub menu events firing

        const $sub_nav = $(this);
        const sub_nav_level = $sub_nav.data('level');
        const $menu_item = $sub_nav.parent();
        const $sub_nav_toggle = $sub_nav.prev('a');
        const open = (e.type == 'show');

        $menu_item.toggleClass('open', open);

        $sub_nav_toggle.attr('aria-expanded', open ? 'true' : 'false');
        $sub_nav_toggle.toggleClass('active', open);

        $main_nav.toggleClass('level-' + sub_nav_level + '-sub-menu-open', open);
      })
      .on('shown.bs.collapse hidden.bs.collapse', function(e) {
        e.stopPropagation();

        // stops firing of main navigation show/hide event
      });

    // toggle collapse on sub menu link
    $main_nav_sub_menu_toggles
      .on('click', function(e){
        e.preventDefault();

        const $sub_nav_toggle = $(this);
        const $sub_nav = $sub_nav_toggle.next('.sub-menu');
        const $children_sub_navs = $sub_nav.find('.sub-menu');

        // hide all sub sub navs
        $children_sub_navs.collapse('hide');

        $sub_nav.collapse('toggle');
      });


    const $parallax_scroll_elements = $('.parallax-on-scroll');

    if($parallax_scroll_elements.length) {
      $(window)
        .on('scroll.parallax_elements', function() {
          const window_height = document.documentElement.clientHeight;
          const scroll_top = $(window).scrollTop();

          $parallax_scroll_elements
            .each(function(index) {
              const $element = $parallax_scroll_elements.eq(index);
              const element_top_offset = $element.offset().top;

              // Check if the element is in the viewport.
              const visible = isInViewport(this);
              let scale = 1;

              if(visible) {
                const diff = Math.abs(element_top_offset - (scroll_top + window_height));
                scale = (diff / window_height) / 4;
                scale = (scale + 1);
              }

              $element
                .css({
                  'transform': 'scale3d(' + scale + ', ' + scale + ', 1)',
                });
            });
        })
        .trigger('scroll.parallax_elements');
    }


    const $parallax_wrap = $('.parallax-on-hover');

    // used for parallax effect
    $parallax_wrap
      .on('mousemove mouseleave', function(e) {
        const $element = $(this);
        const element_offset = $element.offset();
        let x = 0;
        let y = 0;

        if(e.type == 'mousemove') {
          x = (e.pageX - (element_offset.left + Math.floor($element.outerWidth() / 2)));
          y = (e.pageY - (element_offset.top + Math.floor($element.outerHeight() / 2)));
        }

        $element[0].style.setProperty('--mouse-x', x + 'px');
        $element[0].style.setProperty('--mouse-y', y + 'px');
      });


    // Sliders
    let general_slider_options = {
      gutter: 15,
      lazyload: true,
      loop: false,
      nav: false,
      responsive: {},
    };
    general_slider_options.responsive[breakpoints.sm] = {
      items: 2,
      slideBy: 2,
      gutter: 20,
    };
    general_slider_options.responsive[breakpoints.md] = {
      items: 3,
      slideBy: 3,
    };
    general_slider_options.responsive[breakpoints.lg] = {
      items: 4,
      slideBy: 4,
    };
    general_slider_options.responsive[breakpoints.xl] = {
      items: 4,
      slideBy: 4,
    };

    const $wine_slider = $('.js-wine-slider');

    $wine_slider
      .each(function() {
        const $slider = $(this);
        const $slider_prev_btn = $slider.parent().find('.js-slider-prev-btn');
        const $slider_next_btn = $slider.parent().find('.js-slider-next-btn');

        const slider_options = $.extend(
            true,
            {},
            general_slider_options,
            {
              container: $slider[0],
              prevButton: $slider_prev_btn[0],
              nextButton: $slider_next_btn[0],
            }
        );

        slider_options.responsive[breakpoints.lg].items = 3;
        slider_options.responsive[breakpoints.lg].slideBy = 3;

        slider_options.responsive[breakpoints.xl].items = 3;
        slider_options.responsive[breakpoints.xl].slideBy = 3;

        tns(slider_options);
      });

    const $wine_related_slider = $('.js-wine-related-slider');

    if($wine_related_slider.length) {
      const $wine_related_slider_prev_btn = $wine_related_slider.parent().find('.js-slider-prev-btn');
      const $wine_related_slider_next_btn = $wine_related_slider.parent().find('.js-slider-next-btn');

      const wine_related_slider_options = $.extend(
          true,
          {},
          general_slider_options,
          {
            container: $wine_related_slider[0],
            prevButton: $wine_related_slider_prev_btn[0],
            nextButton: $wine_related_slider_next_btn[0],
            nav: true,
          }
      );

      tns(wine_related_slider_options);
    }

    const $wine_downloads_menu = $('#wine-downloads-menu');
    const $wine_downloads_menu_overlay = $('#wine-downloads-menu-overlay')
    const $wine_video_toggle = $('.js-wine-video-toggle');

    $wine_downloads_menu_overlay
      .on('click.fixed-menu-hide', function() {
        $wine_downloads_menu.collapse('hide');
      });

    $wine_downloads_menu
      .on('show.bs.collapse', function() {
        $body.trigger('fixed-menu-show');
      })
      .on('hidden.bs.collapse', function() {
        $body.trigger('fixed-menu-hidden');
      });

    $wine_video_toggle
      .on('click', function(e) {
        e.preventDefault();

        const $section = $('.js-wine-video-section');
        const $video_full = $section.find('.js-wine-video-full');
        const active = $section.hasClass('video-active');
        const src = (active ? 'about:blank' : $video_full.data('src'));

        $section.toggleClass('video-active', !active);

        $video_full.attr('src', src);
      });
  }
});



// WEBPACK FOOTER //
// ./scripts/main.js